<template>
	<ul v-if="errors" class="error-scroll-anchor">
		<li
			v-for="(error) in errors"
			:key="error"
			class="text-xs mt-1"
			:class="{
      'text-qwr-dark-400': isNotice,
      'text-red-600': !isNotice,
    }"
		>
			{{ error }}
		</li>
	</ul>
</template>

<script lang="ts" setup>
export type Props = {
  errors?: string[]
  isNotice?: boolean
}

withDefaults(defineProps<Props>(), {
  errors: undefined,
  isNotice: false,
});
</script>
